export default __webpack_public_path__ + "static/media/red-tires.d41feda1.svg";